import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    building_id: null,
    name: null,
    address: null,
    comments: null,
  },
  mutations,
  actions,
};
